// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);

Vue.config.productionTip = false
// 获取当前地址栏的URL
const currentUrl = window.location.href;

// 获取当前页面的路径部分（不包括协议、域名和查询参数）
const pathname = window.location.pathname;

// 去掉pathinfo和问号后面的内容
const baseUrl1 = currentUrl.replace(pathname, '').replace(window.location.search, '');
console.log('baseUrl1',baseUrl1);

// axios 发起网络请求
import axios from 'axios';
axios.defaults.baseURL ='https://zyychaoshi.weka.life/'; // 服务器域名
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

axios.interceptors.response.use(function(response) {

	return response.data;
}, function(error) {

	return Promise.reject(error);
});


Vue.prototype.$axios = axios;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js